(() => {
  const setupFeaturedRails = (root = document) => {
    root.querySelectorAll('[data-rv-featured-controls]').forEach((controls) => {
      if (controls.dataset.rvFeaturedReady === 'true') return;

      const section = controls.closest('.rv-featured');
      const rail = section?.querySelector('[data-rv-featured-rail]');
      const previous = controls.querySelector('[data-rv-featured-previous]');
      const next = controls.querySelector('[data-rv-featured-next]');
      if (!rail || !previous || !next) return;

      const updateControls = () => {
        const maximum = Math.max(0, rail.scrollWidth - rail.clientWidth);
        controls.hidden = maximum <= 2;
        previous.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft >= maximum - 2;
      };

      const scrollOneCard = (direction) => {
        const card = rail.querySelector('[role="listitem"]');
        if (!card) return;
        const styles = window.getComputedStyle(rail);
        const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
        rail.scrollBy({
          left: direction * (card.getBoundingClientRect().width + gap),
          behavior: 'smooth',
        });
      };

      previous.addEventListener('click', () => scrollOneCard(-1));
      next.addEventListener('click', () => scrollOneCard(1));
      rail.addEventListener('scroll', updateControls, { passive: true });
      window.addEventListener('resize', updateControls, { passive: true });
      controls.dataset.rvFeaturedReady = 'true';
      updateControls();
    });
  };

  setupFeaturedRails();
  document.addEventListener('shopify:section:load', (event) => setupFeaturedRails(event.target));
})();
